import React, { useEffect, useState } from "react";
import { Autocomplete, IconButton, TextField } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link, useNavigate } from "react-router-dom";
import { Card, Typography, Button, CircularProgress } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./cart.css";
import CustomButton from "../components/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import {
  CREATE_ORDER,
  READ_ALL_OFFER,
  READ_CART_ITEMS,
  READ_ONE_USER,
  VALIDATE_PROMOCODE,
} from "../Api/apiConstant";
import {
  useGetAPIQuery,
  useGetAPIWithoutTokenQuery,
  useGetCartDataAPIQuery,
  useOrderpostAPIWithTokenMutation,
  usePostAddToCartWithTokenMutation,
  usePostAPIWithTokenMutation,
  useRemoveFromCartWithTokenMutation,
} from "../Api/api";
import {
  addToCart,
  clearCart,
  removeFromCart,
  removeItemFromCart,
} from "../Features/services/cartSlice";
import { ADD_TO_CART, REMOVE_FROM_CART } from "../Api/apiConstant";
import GlobalButton from "../components/GlobalButton";
import ScrollToTop from "../components/MovotoTop";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
} from "@material-ui/core";
import { styled, alpha } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useThemeColors } from "../Context/Theme";
import { removePromocode, validatePromocode } from "../Features/offers/OfferSlice";
import PaymentForm from "./PaymentForm";
import { isMobile, matchCartItemsToBundles } from "../global/helpers";
import { toast, ToastContainer } from "react-toastify";
import { ErrorOutline } from "@material-ui/icons";
import { Close } from "@mui/icons-material";
import encryptJSON from "../ServiceModule/Encrypt";
import { isProdEnv } from "../ServiceModule/Service";
import { skipToken } from '@reduxjs/toolkit/query/react';
import { getLoggedIn, getToken, getUserId } from "../LoginModule/LoginUtility";
import debounce from "lodash.debounce";


const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: "0.9rem",
  },
}));

const Cart = () => {
  const {
    backgroundColor,
    fontFamily,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading
  } = useThemeColors();
  const [promoCode, setPromoCode] = useState("");
  const navigate = useNavigate();
  const [AddToCart, { isSuccess: addSuccess }] =
    usePostAddToCartWithTokenMutation();
  const [RemoveFromCart, { isSuccess: removeSuccess }] =
    useRemoveFromCartWithTokenMutation();
  const [showPopup, setShowPopup] = useState(false);
  const [productToRemove, setProductToRemove] = useState(null);
  const [appliedBundles, setAppliedBundles] = useState([])
  const [render, setRender] = useState(false);
  const [promocodeData, setPromocodeData] = useState(null);
  const [isApplied, setIsApplied] = useState(false);
  const [isPromocodeError, setIsPromocodeError] = useState(false);
  const [promocodeDiscount, setPromocodeDiscount] = useState(0);
  const [expandedRows, setExpandedRows] = useState(null);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [post] = useOrderpostAPIWithTokenMutation();
  const cartItem = useSelector((state) => state.cart.items);
  const bundle = useSelector((state) => state.cart.bundle);
  const orderSummary = useSelector((state) => state.cart.orderSummary);
  const userId = getUserId()
  const token = getToken()
  const cartId = sessionStorage.getItem("cartId");
  const eventId = sessionStorage.getItem("event_id");
  const eventName = sessionStorage.getItem("eventName");
  const event_city_tax = sessionStorage.getItem("city_tax");
  const event_state_tax = sessionStorage.getItem("state_tax");
  const eventTaxes = sessionStorage.getItem("eventTaxes");
  const [open, setOpen] = useState(false)
  const isLoggedIns = getLoggedIn() === "true";
  const [blankQuantitySku, setBlankQuantitySku] = useState([])
  const [loaderOff, setLoaderOff] = useState(false);
  const eventname = sessionStorage.getItem("event_name");

  const totalEventTaxes =
    parseFloat(event_city_tax) + parseFloat(event_state_tax);

  const { data: readUserData } = useGetAPIQuery(
    isLoggedIns
      ?
      {
        url: `${READ_ONE_USER}user_id=${userId}`,
        token: token,
      }
      : skipToken
  );

  const { data: bundleData } = useGetAPIWithoutTokenQuery(
    `/api/bundle/readAllBundle?event_id=${eventId}&type=active`
  );

  // const shouldSkip = cartId == null || cartId === "" || cartId === "null" || !userId || !eventId; 


  const {
    data: cartData,
    isSuccess: cartSuccess,
    isError: cartError,
    error,
    isFetching,
    refetch
  } = useGetCartDataAPIQuery({
    url: `${READ_CART_ITEMS}cart_id=${cartId}&user_id=${userId}&event_id=${eventId}`,
    token: token,
  },
    { refetchOnMountOrArgChange: true, skip: !cartId }
  );

  const {
    data: offerList,
    isSuccess,
    isError,
    isLoading: offerLoading,
  } = useGetAPIQuery({
    url: eventId
      ? `${READ_ALL_OFFER}?event_id=${eventId}`
      : `${READ_ALL_OFFER}`,
    token: token,
  });

  useEffect(() => {
    const todaysDate = new Date();
    let totalCartAmount = orderSummary?.subtotal;

    let minimumPurchaseDiscount = 0;
    if (offerList?.data?.length > 0 && totalCartItems?.length > 0) {
      const minimumPurchaseOffer = offerList?.data?.find(
        (offer) =>
          offer.minimumpurchase === true &&
          new Date(offer.offer_start_date) <= todaysDate &&
          todaysDate <= new Date(offer.offer_end_date)
      );
      if (minimumPurchaseOffer) {
        const sitewideAmount = Number(
          minimumPurchaseOffer?.minimumpurchase_sitewide_amount || 0
        );
        const discountFixedAmount = Number(
          minimumPurchaseOffer.discount_fixed_amount || 0
        );
        if (totalCartAmount >= sitewideAmount) {
          if (minimumPurchaseOffer.discount_fixed === "Discount") {
            minimumPurchaseDiscount =
              (totalCartAmount * discountFixedAmount) / 100;
          } else {
            minimumPurchaseDiscount = discountFixedAmount;
          }
          totalCartAmount -= promocodeDiscount;
          totalCartAmount -= minimumPurchaseDiscount;

        }
      }
      if (minimumPurchaseDiscount === 0) {
        const sitewideOffer = offerList?.data?.find(
          (offer) =>
            offer.sitewide === true &&
            new Date(offer.offer_start_date) <= todaysDate &&
            todaysDate <= new Date(offer.offer_end_date)
        );
        if (sitewideOffer) {
          const discountFixedAmount = Number(
            sitewideOffer.discount_fixed_amount || 0
          );
          let sitewideDiscount = 0;
          if (sitewideOffer.discount_fixed === "Discount") {
            sitewideDiscount = (totalCartAmount * discountFixedAmount) / 100;
          } else {
            sitewideDiscount = discountFixedAmount;
          }
          totalCartAmount -= promocodeDiscount;
          totalCartAmount -= sitewideDiscount;
        }
      }

    }
    if (cartItem?.length > 0 || bundle.length > 0) {
      const afterAppliedBundleData = matchCartItemsToBundles(cartItem, bundleData?.data || [])
      setAppliedBundles(afterAppliedBundleData?.appliedBundles?.map(i => { return { ...i, total_price: i?.discount_amount } }))
    }
  }, [isSuccess, addSuccess, removeSuccess, cartItem, bundle, promocodeData]);

  useEffect(() => {
    if (orderSummary?.promocodeApplied) {
      setPromoCode(orderSummary?.promocodeApplied)
      setIsApplied(true);
      if (orderSummary?.promoCodeError) {
        toast.error(orderSummary?.promoCodeError)
        setTimeout(() => {
          setIsApplied(false);
          handleRemovePromoCode()
          setPromoCode("")
        }, 1000);
      }
    }
  }, [orderSummary?.promocodeApplied]);

  const handleExpandClick = (bundleId) => {
    setExpandedRows(bundleId);
  };

  const isLoggedIn = getLoggedIn() === "true";

  const dispatch = useDispatch();

  const itemsInTheCart = useSelector((state) => state.cart.items);

  const debouncedHandleChangeQuantity = debounce((product, value) => {
    handleAddToCart(product, value);
  }, 300);

  const handleAddToCart = async (product, value) => {
    setLoaderOff(true)
    await handleRemovePromoCode()
    if (value === "") {
      setBlankQuantitySku(prev => [...prev, product.item_id])
      handleRemoveFromCart(product, "")
      return;
    }
    if (value === 0) {
      handleRemoveFromCart(product, 0)
      return;
    }
    setBlankQuantitySku(blankQuantitySku.filter(n => n !== product.item_id))
    const bundleId = product?.product_id || product?.bundle_id;

    if (!bundleId) {
      const filteredProduct = cartItem?.find(
        (item, index) => item?.product_id === product?.product_id
      );

      const { product_details } = filteredProduct;

      const filterSkus = product_details?.skus.filter(
        (item, index) => item.sku_id === product.sku_id
      );

      const updatedProduct = { ...filteredProduct, skus: filterSkus };
    }

    const newCartItem = {
      product_id: product?.product_id,
      sku_id: product?.product_details?.skus[0]?.sku_id,
      quantity: value ? value : product?.quantity + 1,
      price: product?.price,
    };

    const bundleItem = {
      bundle_id: bundleId,
      quantity: product?.quantity,
      price: product?.discount_amount,
    };

    if (isLoggedIn) {
      // dispatch(
      //   addToCart({
      //     ...product,
      //     quantity: bundleId ? bundleItem?.quantity : newCartItem?.quantity,
      //   })
      // );
      const matchedBundleData = matchCartItemsToBundles([...cartItem?.filter(cart => cart?.product_id != product?.product_id), {
        ...product,
        quantity: newCartItem?.quantity,
      }], bundleData?.data || [])
      // }], bundleData?.data)
      const matchedData = matchedBundleData?.appliedBundles?.map(applyBundle => {
        return {
          bundleId: applyBundle?.bundle_id,
          bundleProductIds: applyBundle?.bundleProduct?.map(bundleProduct => bundleProduct?.product?.product_id),
          bundleQuantity: applyBundle?.quantity
        }
      })

      try {
        const { data } = await AddToCart({
          url: ADD_TO_CART,
          formData: {
            user_id: userId,
            items: [product?.product_id ? newCartItem : bundleItem],
            event_id: eventId,
            bundleData: matchedData
          },
          token: token,
        });
        setRender(!render);
      } catch (error) {

      }
    } else {
      navigate(`/events/${eventName}/login`);
    }
  };

  const handleRemoveFromCart = async (product, value) => {
    setLoaderOff(true)
    await handleRemovePromoCode()
    // if(value === "")
    // {
    //   handleRemoveAll(product)
    //   return;
    // }
    if (!product) return;

    const bundleId = product?.bundle_id;
    const isBundle = !!bundleId;

    const prepareCartItem = () => {
      if (product?.product_id) {
        return {
          ...product,
          skus: product?.product_details?.skus,
          quantity: value === "" ? 0 : product?.quantity > 1 ? product?.quantity - 1 : 0,
        };
      }

      return {
        bundle_id: bundleId,
        quantity: value === "" ? 0 : product?.quantity > 1 ? product?.quantity - 1 : 0,
        price: product?.discount_amount,
      };
    };

    const cartItem = prepareCartItem();

    if (!isLoggedIn) {
      navigate(`/events/${eventName}/login`);
      return;
    }

    try {
      if (product.quantity > 1 || value === "") {
        dispatch(
          removeFromCart({
            ...(isBundle ? { itemId: bundleId, type: "bundle" } : cartItem),
            quantity: cartItem.quantity,
          })
        );

        let dataformatch = itemsInTheCart?.filter(d => d.product_id != product?.product_id)
        const matchedBundleData = matchCartItemsToBundles([...dataformatch, cartItem], bundleData?.data || [])
        const matchedData = matchedBundleData?.appliedBundles?.map(applyBundle => {
          return {
            bundleId: applyBundle?.bundle_id,
            bundleProductIds: applyBundle?.bundleProduct?.map(bundleProduct => bundleProduct?.product?.product_id),
            bundleQuantity: applyBundle?.quantity
          }
        })
        await AddToCart({
          url: ADD_TO_CART,
          formData: {
            user_id: userId,
            items: [cartItem],
            event_id: eventId,
            bundleData: matchedData,
            callFrom: 'Remove'
          },
          token,
        });
      } else if ((product?.quantity === 1 || value === 0) && value !== "") {
        handleOpenPopup(product);
      }
      setRender(!render);
    } catch (error) {
      console.error("Error while removing from cart: ", error);

      dispatch(
        addToCart({
          ...(isBundle
            ? cartItem
            : { ...cartItem, quantity: cartItem.quantity + 1 }),
        })
      );
    }
  };


  const handleRemoveAll = async (product) => {
    if (product?.product_id) {
      const filteredProduct = cartItem?.find(
        (item) => item?.product_id === product?.product_id
      );

      const { product_details } = filteredProduct;

      const matchedSku = product_details?.skus?.find(
        (sku) => sku.sku_id === product?.product_details?.skus[0]?.sku_id
      );

      const updatedProduct = { ...filteredProduct, skus: [matchedSku] };

      if (isLoggedIn) {
        dispatch(removeItemFromCart({ itemId: product?.product_id }));
        try {
          const { data } = await RemoveFromCart({
            url: REMOVE_FROM_CART,
            formData: {
              cart_id: cartId,
              product_id: product?.product_id,
              sku_id: product?.sku_id,
              event_id: eventId,
            },
            token: token,
          });
        } catch (error) {

        }
      }
    } else {
      if (isLoggedIn) {
        dispatch(removeItemFromCart({ itemId: product?.bundle_id }));
        try {
          const { data } = await RemoveFromCart({
            url: REMOVE_FROM_CART,
            formData: {
              cart_id: cartId,
              bundle_id: product?.bundle_id,
              event_id: eventId,
            },
            token: token,
          });
        } catch (error) {

        }
      }
    }
  };

  const handleApply = async () => {
    setLoaderOff(false)
    const { payload } = await dispatch(
      validatePromocode({ cart_id: cartId, promocode: promoCode, userId, token })
    );
    refetch()
    if (payload?.status && promoCode) {
      setIsApplied(true);
      setPromocodeData(payload?.data);
    } else {
      setIsPromocodeError(true);
    }
  };
  // handleAddToCart
  async function handleRemovePromoCode() {
    setLoaderOff(false)
    setPromocodeData(null);
    setPromoCode("");
    setPromocodeDiscount(0);
    setIsApplied(false);
    promoCode && await dispatch(
      removePromocode({ cart_id: cartId, token })
    );
    refetch()
  };

  const handleOpenPopup = (product) => {
    setProductToRemove(product);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setProductToRemove(null);
  };

  const handleConfirmRemove = async () => {
    if (isLoggedIn && productToRemove) {
      await handleRemovePromoCode()
      await handleRemoveAll(productToRemove);
      setShowPopup(false);
      setRender(!render);
    }
  };

  const discountDetails = {
    discountBreakdown: orderSummary?.discountBreakdown
  };

  const taxDetails = {
    taxdata: orderSummary?.taxdata,
    finalTaxDetails: orderSummary?.filteredTaxTotals,
    customNameList: orderSummary?.customNameList
  };

  const handleCompleteOrder = async (paymentStatus, paymentId) => {
    if (paymentStatus && paymentId) {
      try {
        let discountData = {
          totalDiscount: parseFloat(orderSummary?.discount),
          regularDiscount: 0,
          offerDiscount: 0,
          categoryDiscount: 0,
          sitewideDiscount: 0
        }
        orderSummary?.discountBreakdown?.forEach(item => {
          switch (item.discountTitle) {
            case 'Regular Discount':
              discountData.regularDiscount = parseFloat(item?.amount || 0);
              break;
            case 'Offer Discount':
              discountData.offerDiscount = parseFloat(item?.amount || 0);
              break;
            case 'Category Discount':
              discountData.categoryDiscount = parseFloat(item?.amount || 0);
              break;
            case 'Sitewide Discount':
              discountData.sitewideDiscount = parseFloat(item?.amount || 0);
              break;
          }
        });
        let freezedOrder = {
          user_email: readUserData?.user_email,
          subTotal: parseFloat(orderSummary?.subtotal),
          discount: discountData,
          discountedPrice: parseFloat(orderSummary?.discountedPrice),
          tax: {
            totalTax: orderSummary?.totalTax,
            taxdata: orderSummary?.taxdata
          },
          totalPrice: orderSummary?.totalPrice,
          promocode: {
            promocodeDiscount: orderSummary?.promocodeDiscount,
            promocodeText: promoCode
          },
          bundleDiscount: orderSummary?.bundleDiscount,
          discountBreakdown: orderSummary?.discountBreakdown,
          products: cartItem?.map(product => ({
            productId: product?.product_id,
            productImage: product?.product_details?.productImg[0]?.product_img,
            productSkuName: product?.product_details?.skus[0]?.sku_name,
            productName: product?.product_details?.product_name,
            productUnit: product?.product_details?.skus[0]?.unit,
            productQuantity: product?.quantity,
            productRegularPrice: product?.product_details?.skus?.[0]?.regular_price * product?.quantity,
            productDiscountedPrice: product?.totalDiscount ? product?.totalDiscount : 0,
            productAgeValidation: product?.product_details?.categories[0]?.age_validation,
          })),
          bundles: []
        }

        let updatedData = {
          user_email: readUserData?.user_email,
          event_id: eventId,
          user_id: userId,
          cart_id: cartId,
          order_status_id: 1,
          payment_status: paymentStatus,
          payment_id: paymentId,
          sub_totalprice: parseFloat(orderSummary?.subtotal).toFixed(2),
          discount: parseFloat(discountData?.totalDiscount)?.toFixed(2),
          promocode_discount: orderSummary?.promocodeDiscount,
          promocode: promoCode,
          cart_totalprice: parseFloat(orderSummary?.totalPrice).toFixed(2),
          tax_totalprice: parseFloat(orderSummary?.totalTax).toFixed(2),
          discount_totalprice: parseFloat(orderSummary?.discountedPrice)?.toFixed(2),
          order_data: freezedOrder,
          order_analysis: "Website",
          tax_details: JSON.stringify(taxDetails),
          discount_details: JSON.stringify(discountDetails),
        }

        if (isProdEnv == "true") {
          const encryptedPayload = encryptJSON(updatedData, "FO" + userId + "AdminCheckAuthorization2025");
          updatedData = {
            element: encryptedPayload,
            user_id: userId,
          }
        }

        const { data } = await post({
          url: CREATE_ORDER,
          formData: updatedData,
          token: token,
        });
        if (data?.status === true) {
          onClose()
          navigate(`/events/${eventName}/confirm-order`, {
            state: {
              order_id: data?.order_id,
              totalDiscount: parseFloat(parseFloat(orderSummary?.discount) + parseFloat(orderSummary?.promocodeDiscount) + parseFloat(orderSummary?.bundleDiscount)).toFixed(2),
              status: "COMPLETED"
            },
          });
          dispatch(clearCart());
        }
        if (data?.status === true && paymentStatus == "COMPLETED") {
          onClose()
          navigate(`/events/${eventName}/confirm-order`, {
            state: {
              order_id: data?.order_id,
              totalDiscount: parseFloat(parseFloat(orderSummary?.discount) + parseFloat(orderSummary?.promocodeDiscount) + parseFloat(orderSummary?.bundleDiscount)).toFixed(2),
              status: paymentStatus
            },
          });
          dispatch(clearCart());
        }
        else if (data && paymentStatus == "PENDING") {
          onClose()
          navigate(`/events/${eventName}/confirm-order`, {
            state: {
              order_id: data?.order_id,
              totalDiscount: parseFloat(parseFloat(orderSummary?.discount) + parseFloat(orderSummary?.promocodeDiscount) + parseFloat(orderSummary?.bundleDiscount)).toFixed(2),
              status: paymentStatus
            },
          });
          dispatch(clearCart());
        }
        else if (data && (paymentStatus == "CANCELED" || paymentStatus == "FAILED" || paymentStatus == "DECLINED")) {
          onClose()
          navigate(`/events/${eventName}/confirm-order`, {
            state: {
              order_id: data?.order_id,
              totalDiscount: parseFloat(parseFloat(orderSummary?.discount) + parseFloat(orderSummary?.promocodeDiscount) + parseFloat(orderSummary?.bundleDiscount)).toFixed(2),
              status: paymentStatus
            },
          });
          dispatch(clearCart());
        }
        else if (!data) {
          navigate(`/events/${eventName}/confirm-order`, {
            state: {
              order_id: null,
              totalDiscount: null,
              status: null
            },
          });
        }
        else {

        }
      } catch (error) {

        navigate(`/events/${eventName}/confirm-order`, {
          state: {
            order_id: null,
            totalDiscount: null,
            status: null
          },
        });
      }
    }
  }


  const onClose = async () => {
    setOpen(false)
  }


  const breadcrumbs = [
    <Link
      to={`/events/${eventName}`}
      className="text-decoration-none font-size text-secondary"
      style={{ fontSize: "17px", fontFamily }}
      underline="hover"
      key="1"
      color="inherit"
      href="/"
    >
      {eventname}
    </Link>,

    <Typography key="3" color="text.primary" style={{ fontSize: "17px", fontFamily }}>
      Cart
    </Typography>,
  ];

  const totalCartItems = [...cartItem, ...bundle];

  const isMob = isMobile()

  const totalAmount = orderSummary?.totalPrice

  const handleOrder = (totalAmount) => {
    // Convert totalAmount to a number and ensure it's valid
    const amount = parseFloat(totalAmount);

    if (isNaN(amount) || amount <= 0) {
      setErrorDialogOpen(true);
    } else {
      setOpen(true);
    }
  };


  const handleCloseErrorDialog = () => {
    setErrorDialogOpen(false);
  };

  return (
    <div className="overflow-hidden" style={{ background: backgroundColor }}>
      <Dialog
        open={errorDialogOpen}
        onClose={handleCloseErrorDialog}
      >
        <Box
          sx={{
            padding: '15px',
            paddingLeft: '0px',
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: "0px", right: "0px" }}
            aria-label="close"
            onClick={handleCloseErrorDialog}
          >
            <Close />
          </IconButton>
          <DialogTitle
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ErrorOutline color="error" sx={{ marginRight: '8px' }} />
              Something went wrong
            </Box>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              The amount must be more than $0.00. Please <Link to={`/events/${eventName}/contact`}>contact the administrator</Link>.
            </Typography>
          </DialogContent>
        </Box>
      </Dialog>


      <ToastContainer autoClose={2000} />
      {/* <ScrollToTop /> */}
      <Navbar className="sticky-navbar" />
      {(offerLoading) ? (
        <div
          style={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress sx={{ color: "red" }} />
        </div>
      ) : (
        <>
          {isFetching && !loaderOff && <div
            style={{
              height: "100vh",
              width: "100vw",
              display: "flex",
              position: 'fixed',
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgb(255 255 255 / 63%)",
            }}
          >
            <CircularProgress sx={{ color: "red", zIndex: 99999 }} />
          </div>}
          {" "}
          <div style={{ margin: "2% 3%", marginTop: "18vh" }}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </div>
          {totalCartItems?.length > 0 ? (
            <Box>
              <Grid
                container
                spacing={2}
                style={{ padding: "10px", borderBottom: "1px solid #F6F6F6" }}
              >
                <Grid item xs={12} sm={12} md={8}>
                  {cartItem.length > 0 && (
                    <TableContainer
                      component={Paper}
                      className="custom-scrollbar"
                      style={{
                        borderRadius: "21px",
                        maxHeight: "67vh",
                        overflowY: "auto",
                        width: "100%",
                        paddingRight: "2%",
                        marginRight: "2%",
                        marginBottom: "5%",
                      }}
                    >
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow style={{}}>
                            <TableCell
                              className=""
                              style={{
                                paddingLeft: "1.6em",
                                fontWeight: 600,
                                color: "black",
                                fontFamily
                              }}
                            >
                              Product
                            </TableCell>
                            <TableCell></TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: 600, color: "black", fontFamily }}
                            >
                              Quantity
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: 600, color: "black", fontFamily }}
                            >
                              Price
                            </TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center"></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {cartItem?.map((product) => {
                            return (
                              <TableRow key={product.id}>
                                <TableCell>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: "10vh",
                                        width: "30%",
                                        backgroundColor: "#F4F4F4",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: "0.5em",
                                        position: "relative",
                                      }}
                                    >
                                      <img
                                        src={
                                          product.product_id
                                            ? product?.product_details
                                              ?.productImg[0]?.product_img
                                            : product?.bundleProducts[0]
                                              ?.product_img[0]?.product_img
                                        }
                                        style={{
                                          height: "8vh",
                                          width: "8vh",
                                          objectFit: "contain",
                                        }}
                                        alt={
                                          product?.product_details?.skus[0]
                                            ?.sku_name
                                        }
                                      />
                                    </div>

                                    <div
                                      style={{
                                        marginLeft: "10%",
                                        height: "8vh",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                      }}
                                    >
                                      <span
                                        className=""
                                        style={{
                                          fontSize: "1em",
                                          color: "#3a3a3a",
                                          fontWeight: "700",
                                          fontFamily
                                        }}
                                      >
                                        {product?.product_details?.product_name}
                                      </span>
                                      <span
                                        style={{
                                          fontSize: "0.8em",
                                          color: "#3a3a3a",
                                          fontWeight: "500",
                                          fontFamily
                                        }}
                                      >
                                        {product?.product_id
                                          ? product?.product_details?.skus[0]
                                            ?.unit
                                          : "bundle"}
                                      </span>
                                    </div>
                                  </div>
                                </TableCell>

                                <TableCell
                                  align="center"
                                  style={{
                                    fontSize: "0.9em",
                                    color: "#3a3a3a",
                                    fontWeight: "600",
                                    fontFamily
                                  }}
                                ></TableCell>

                                <TableCell
                                  align="center"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "15vh",
                                  }}
                                >
                                  <div style={styles.quantityContainer}>
                                    <button
                                      style={styles.button}
                                      onClick={() =>
                                        handleRemoveFromCart(product)
                                      }
                                    >
                                      -
                                    </button>
                                    <input
                                      type="number"
                                      step="1"
                                      min="0"
                                      max="9999"
                                      value={
                                        blankQuantitySku.includes(product.item_id)
                                          ? ""
                                          : product.quantity
                                      }
                                      style={{ ...styles.input, fontFamily }}
                                      onChange={(e) => {
                                        const val = e.target.value;

                                        // Allow clearing input
                                        if (val === "") {
                                          handleAddToCart(product, "");
                                          return;
                                        }

                                        // Only allow integers in the valid range
                                        const value = parseInt(val, 10);
                                        if (!isNaN(value) && value >= 0 && value <= 9999) {
                                          handleAddToCart(product, value);
                                          return;
                                        }
                                      }}
                                      onFocus={(e) => e.target.select()}
                                      onKeyDown={(e) => {
                                        // Block characters: . , e + -
                                        if (
                                          ["e", "E", ".", ",", "+", "-"].includes(e.key)
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      inputMode="numeric"
                                    />

                                    <button
                                      style={styles.button}
                                      onClick={() => handleAddToCart(product)}
                                    >
                                      +
                                    </button>
                                  </div>
                                </TableCell>
                                <TableCell align="center" style={{ fontFamily }}>
                                  <p style={{ fontFamily }}>
                                    {
                                      (product?.product_details?.skus?.[0]
                                        ?.regular_price * product?.quantity)?.toFixed(2) === product?.totalDiscount
                                        ?
                                        <span style={{
                                          fontSize: "1em",
                                          color: "#3a3a3a",
                                          fontWeight: "700",
                                          fontFamily
                                        }}>
                                          $
                                          {(product?.product_details?.skus?.[0]
                                            ?.regular_price * product?.quantity)?.toFixed(2)}
                                        </span>
                                        :
                                        <del style={{ fontFamily }}>
                                          $
                                          {(product?.product_details?.skus?.[0]
                                            ?.regular_price * product?.quantity)?.toFixed(2)}
                                        </del>

                                    }

                                  </p>
                                  {
                                    (product?.product_details?.skus?.[0]
                                      ?.regular_price * product?.quantity)?.toFixed(2) !== product?.totalDiscount
                                    &&

                                    <p
                                      className=""
                                      style={{
                                        fontSize: "1em",
                                        color: "#3a3a3a",
                                        fontWeight: "700",
                                        fontFamily
                                      }}
                                    >
                                      $
                                      {
                                        product?.totalDiscount ?
                                          product.totalDiscount : ""
                                      }
                                    </p>
                                  }
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  {product?.product_details?.categories[0]
                                    ?.age_validation !== "No" && (
                                      <Tooltip
                                        title={
                                          <div
                                            style={{
                                              backgroundColor: "#FFF4F5",
                                              border: "1px solid #FE3B3E",
                                              color: "#FE3B3E",
                                              padding: "0.3rem",
                                              fontFamily
                                            }}
                                          >
                                            Show your Govt I'd at the time of pick
                                            up
                                          </div>
                                        }
                                        placement="top"
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor: "transparent",
                                              boxShadow: "none",
                                              padding: 0,
                                            },
                                          },
                                        }}
                                      >
                                        <InfoOutlinedIcon sx={{ color: "red", width: "16px", height: "16px" }} />
                                      </Tooltip>
                                    )}
                                  &nbsp;&nbsp;
                                  {product?.bundleMessage && (
                                    <Tooltip
                                      title={
                                        <div
                                          style={{
                                            backgroundColor: "#13d85e",
                                            border: "1px solid #13d85e",
                                            color: "#065826",
                                            padding: "0.3rem",
                                            fontFamily
                                          }}
                                        >
                                          {product?.bundleMessage}
                                        </div>
                                      }
                                      placement="top"
                                      componentsProps={{
                                        tooltip: {
                                          sx: {
                                            backgroundColor: "transparent",
                                            boxShadow: "none",
                                            padding: 0,
                                          },
                                        },
                                      }}
                                    >
                                      <InfoOutlinedIcon sx={{ color: "green", width: "16px", height: "16px" }} />
                                    </Tooltip>
                                  )}
                                </TableCell>

                                <TableCell
                                  align="center"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleOpenPopup(product)}
                                >
                                  <img
                                    src={require("../Images/X.png")}
                                    alt="Remove"
                                  />
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}

                </Grid>
                <Dialog open={showPopup}>
                  <DialogTitle
                    style={{
                      fontSize: "2em",
                      color: "#23262F",
                      fontWeight: "700",
                      fontFamily
                    }}
                  >
                    Confirm{" "}
                  </DialogTitle>
                  <DialogContent style={{ fontFamily }}>
                    Are you sure you want to remove?
                  </DialogContent>
                  <DialogActions
                    style={{
                      justifyContent: "center",
                      display: "flex",
                      gap: "20px",
                    }}
                  >
                    <CustomButton
                      text="Yes"
                      size="lg"
                      className="mt-4 mb-3 custom-dialog-width"
                      block={true}
                      onClick={handleConfirmRemove}
                    />

                    <CustomButton
                      text="No"
                      size="sm"
                      block={true}
                      className="mt-4 mb-3 custom-dialog-width"
                      bgcolor="black"
                      onClick={handleClosePopup}
                    />


                  </DialogActions>
                </Dialog>

                <Grid item xs={12} sm={12} md={4}>
                  <Card
                    className="p-4 custom-scrollbar"
                    style={{
                      boxShadow:
                        "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                      margin: "0% 2%",
                      borderRadius: "21px",
                      maxHeight: isMob ? "70vh" : "67vh",
                      minHeight: isMob ? "70vh" : "67vh",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-around",
                      alignItems: "flex-start",
                      overflowY: "auto",
                      fontFamily
                    }}
                  >
                    <p className="pb-2 order-heading borderClass" style={{ fontFamily: fontFamilyHeading, fontSize: fontSizeHeading, fontWeight: fontWeightHeading }}>
                      Order Summary
                    </p>
                    <Grid
                      container
                      spacing={2}
                      style={{ borderBottom: "1px solid #EAEAEA" }}
                    >
                      <Grid
                        item
                        xs={6}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            fontFamily
                          }}
                        >
                          Sub Total
                        </p>
                        {orderSummary?.discountBreakdown?.length > 0 && (
                          <p
                            style={{
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              cursor: "pointer",
                              fontFamily
                            }}
                          >
                            Discount
                            <LightTooltip
                              placement="right-start"
                              title={
                                <div>
                                  {orderSummary?.discountBreakdown?.map(discountData => {
                                    return (
                                      <>
                                        <div
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "0.8rem",
                                            fontFamily,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                          }}
                                        >
                                          { }
                                          <span
                                            style={{
                                              fontSize: "0.6rem",
                                              fontWeight: "600",
                                              fontFamily
                                            }}
                                          >
                                            {discountData?.discountTitle}
                                          </span>
                                          <span
                                            style={{
                                              whiteSpace: "pre-wrap",
                                              display: "block",
                                              marginLeft: "2vw",
                                              fontSize: "0.6rem",
                                              fontFamily,
                                              color: "green"
                                            }}
                                          >
                                            {" "}
                                            $
                                            <strong style={{ fontSize: "0.6rem", fontFamily }}>

                                              {discountData?.amount}
                                            </strong>
                                          </span>
                                        </div>
                                      </>
                                    )
                                  })}
                                </div>
                              }
                            >
                              <InfoOutlinedIcon
                                fontSize="small"
                                sx={{ cursor: "pointer", marginLeft: '12px', width: "16px", height: "16px" }}
                              />
                            </LightTooltip>
                          </p>
                        )}
                        {Number(orderSummary?.bundleDiscount) > 0 && (
                          <p
                            style={{
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              cursor: "pointer",
                            }}
                          >
                            Bundle Discount
                          </p>
                        )}
                        {Number(orderSummary?.promocodeDiscount) > 0 && (
                          <p
                            style={{
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              cursor: "pointer",
                              fontFamily
                            }}
                          >
                            Promocode Discount
                          </p>
                        )}
                        {Number(orderSummary?.discountedPrice) > 0 && (
                          <p
                            style={{
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              cursor: "pointer",
                              fontFamily
                            }}
                          >
                            Discounted Price
                          </p>
                        )}

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "35%",
                            // justifyContent: "space-between",
                            fontFamily
                          }}
                        >
                          <p
                            style={{
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              cursor: "pointer",
                              fontFamily
                            }}
                          >
                            Tax
                            <span
                              style={{
                                fontSize: "0.5rem",
                                fontWeight: "600",
                                fontFamily
                              }}
                            >
                              {" "}
                              (%)
                            </span>
                          </p>
                          {
                            orderSummary?.totalTax > 0 &&
                            <LightTooltip
                              placement="right-start"
                              title={
                                <div
                                  style={{
                                    maxHeight: "300px", // Adjust as needed
                                    overflowY: "auto",
                                    paddingRight: "8px"
                                  }}
                                >
                                  {
                                    orderSummary?.filteredTaxTotals?.map((tax, index) => {
                                      return (
                                        <div key={index}>
                                          <div
                                            style={{
                                              fontWeight: "600",
                                              fontSize: "0.8em",
                                              fontFamily,
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <span
                                              style={{
                                                fontSize: "0.8em",
                                                fontFamily,
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              <strong style={{ fontSize: "1.2em", fontFamily }}>
                                                {tax.type} Tax {tax.type === "Custom" ? <span className="text-danger"><br />{orderSummary?.customNameList}</span> : ""}
                                              </strong>
                                              <br />
                                            </span>
                                            <br />
                                            <span
                                              style={{
                                                whiteSpace: "pre-wrap",
                                                color: "red",
                                                marginLeft: "2vw",
                                                fontSize: "0.8em",
                                                fontFamily,
                                                alignItems: "flex-end",
                                              }}
                                            >
                                              <strong style={{ fontSize: "1.2em", fontFamily }}>
                                                {" "}Tax Amount: ${tax?.amount}
                                              </strong>
                                              <br />
                                            </span>
                                          </div>
                                        </div>
                                      )
                                    })
                                  }
                                </div>
                              }
                            >
                              <InfoOutlinedIcon
                                fontSize="small"
                                sx={{ cursor: "pointer", marginLeft: '12px', width: "16px", height: "16px" }}
                              />
                            </LightTooltip>
                          }
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          textAlign: "right",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#484848",
                            fontFamily,
                            textDecoration: (parseFloat(orderSummary?.discount) > 0 || parseFloat(orderSummary?.bundleDiscount) > 0)
                              &&
                              "line-through",
                          }}
                        >
                          ${orderSummary?.subtotal || 0}
                        </p>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div>
                            {" "}
                            {/* {Number(orderSummary?.discount) > 0 && ( */}
                            <p
                              style={{
                                fontSize: "0.7rem",
                                width: "100%",
                                color: "green",
                                fontFamily,
                                fontWeight: "600",
                              }}
                            >
                              $ {orderSummary?.discount || 0}
                            </p>
                            {/* )} */}
                          </div>
                          {Number(orderSummary?.bundleDiscount) > 0 && (
                            <div>
                              <p
                                style={{
                                  fontSize: "0.7rem",
                                  width: "100%",
                                  color: "green",
                                  fontWeight: "600",
                                  fontFamily,
                                }}
                              >
                                $ {orderSummary?.bundleDiscount || 0}
                              </p>
                            </div>
                          )}
                          {orderSummary?.promocodeDiscount && Number(orderSummary?.promocodeDiscount) > 0 && (
                            <div>
                              <p
                                style={{
                                  fontSize: "0.7rem",
                                  width: "100%",
                                  color: "green",
                                  fontWeight: "600",
                                  fontFamily
                                }}
                              >
                                ${orderSummary?.promocodeDiscount || 0}
                              </p>
                            </div>
                          )}
                          {orderSummary?.discountedPrice && Number(orderSummary?.discountedPrice) > 0 && (
                            <p
                              style={{
                                fontSize: "1rem",
                                fontWeight: "700",
                                cursor: "pointer",
                                fontFamily
                              }}
                            >
                              ${orderSummary?.discountedPrice || 0}
                            </p>
                          )}
                        </div>


                        <p
                          style={{
                            fontSize: "0.8rem",
                            fontWeight: "600",
                            marginBottom: "1.5vh",
                            color: "red",
                            fontFamily
                          }}
                        >
                          {" "}
                          ${orderSummary?.totalTax || 0}
                        </p>
                      </Grid>
                    </Grid>

                    <Grid container spacing={2} className="pt-1">
                      <Grid
                        item
                        xs={4}
                        style={{
                          textAlign: "left",
                          display: "flex",
                          justifyContent: "flex-end",
                          flexDirection: "column",
                        }}
                      >
                        <p style={{ fontSize: "16px", fontWeight: "500", fontFamily }}>
                          Total Price:
                        </p>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        style={{
                          textAlign: "right",
                          fontWeight: "700",
                          fontFamily
                        }}
                      >
                        ${orderSummary?.totalPrice && Number(orderSummary?.totalPrice) > 0 ? orderSummary?.totalPrice : 0}
                      </Grid>
                    </Grid>

                    {/* <div
                      className="d-flex"
                      style={isMob ? {
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        width: "100%",
                        fontFamily,
                        alignItems: "flex-start",
                      } : {
                        width: "100%",
                        alignItems: isPromocodeError ? "flex-start" : "flex-start",
                        fontFamily
                      }}
                    >
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          margin: 0,
                          fontFamily
                        }}
                      >
                        Promocode
                        <LightTooltip
                          placement="right-start"
                          title={
                            <div
                              style={{
                                fontWeight: "600",
                                fontSize: "0.8em",
                                fontFamily,
                                display: "flex",
                                justifyContent: "space-between",
                                color: "red"
                              }}
                            >
                              Coupon code is not applied to the bundle product quantity.
                            </div>
                          }
                        >
                          <InfoOutlinedIcon
                            fontSize="small"
                            sx={{ cursor: "pointer" }}
                          />
                        </LightTooltip> :
                      </p>
                      {!isApplied ? (
                        <>
                          <div
                            style={{
                              height: "max-content",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                              fontFamily
                            }}
                          >
                            <TextField
                              value={promoCode}
                              onChange={(e) => {
                                setPromoCode(e.target?.value);
                                setIsPromocodeError(false);
                              }}
                              variant="standard"
                              placeholder="Enter promocode..."
                              style={isMob ? {
                                borderRadius: "0.5em",
                                width: "60vw",
                                paddingLeft: "0.5rem",
                                marginTop: '5px',
                                fontFamily
                              } : {
                                borderRadius: "0.5em",
                                width: "12vw",
                                marginLeft: "1rem",
                                paddingLeft: "0.5rem",
                                fontFamily
                              }}
                              error={isPromocodeError}
                              helperText={
                                isPromocodeError ? "Invalid promo code." : ""
                              }
                              InputProps={{
                                disableUnderline: true,
                                style: {
                                  border: "1px solid",
                                  borderColor: isPromocodeError
                                    ? "red"
                                    : "#ccc",
                                  borderRadius: "16px",
                                  paddingLeft: "10px",
                                  fontFamily
                                },
                              }}
                            />
                            <Button disabled={!promoCode} className="mx-3" style={{ fontFamily }} onClick={handleApply}>
                              Apply
                            </Button>
                          </div>
                        </>
                      ) : (
                        <Box
                          style={{
                            display: "flex",
                            marginLeft: "1rem",
                            width: "20vw",
                            justifyContent: "space-between",
                            fontFamily
                          }}
                        >
                          <Chip
                            label={promoCode}
                            style={{
                              marginRight: "1rem",
                              borderRadius: "1em",
                              fontSize: "1rem",
                              padding: "0.5rem",
                              border: "2px solid #008000",
                              color: "#008000",
                              fontFamily
                            }}
                            variant="filled"
                            onDelete={async () => await handleRemovePromoCode()}
                          />
                        </Box>
                      )}
                    </div> */}

                    <Grid container spacing={2} alignItems="center" style={{ width: "105%", marginTop: isMob ? '5px' : 0 }}>
                      {/* Label - 3 columns */}
                      <Grid item xs={12} md={4}>
                        <p style={{ fontSize: "16px", fontWeight: "500", margin: 0, fontFamily }}>
                          Promocode:
                          <LightTooltip
                            placement="right-start"
                            title={
                              <div
                                style={{
                                  fontWeight: "600",
                                  fontSize: "0.8em",
                                  fontFamily,
                                  display: "flex",
                                  justifyContent: "space-between",
                                  color: "red",
                                }}
                              >
                                Coupon code is not applied to the bundle product quantity.
                              </div>
                            }
                          >
                            <InfoOutlinedIcon fontSize="small" sx={{ cursor: "pointer", marginLeft: 1, width: "16px", height: "16px" }} />
                          </LightTooltip>
                        </p>
                      </Grid>

                      {/* Input field - 6 columns */}
                      {
                        !isApplied ?
                          <>
                            <Grid item xs={12} md={6}>
                              <TextField
                                sx={{ mt: 2 }}
                                value={promoCode}
                                onChange={(e) => {
                                  setPromoCode(e.target?.value.trimStart());
                                  setIsPromocodeError(false);
                                }}
                                variant="standard"
                                placeholder="Enter promocode..."
                                fullWidth
                                error={isPromocodeError}
                                helperText={isPromocodeError ? "Invalid promo code." : "\u00a0"} // 👈 keeps the height stable
                                InputProps={{
                                  disableUnderline: true,
                                  style: {
                                    border: "1px solid",
                                    borderColor: isPromocodeError ? "red" : "#ccc",
                                    borderRadius: "16px",
                                    paddingLeft: "10px",
                                    fontFamily,
                                  },
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={2} style={{ display: "flex" }}>
                              <Button disabled={!promoCode} onClick={handleApply} style={{ fontFamily }}>
                                Apply
                              </Button>
                            </Grid>
                          </>
                          :
                          <Grid item xs={12} md={8}>
                            <Box
                              style={{
                                display: "flex",
                                justifyContent: "flex-end", // aligns content to the end
                                width: "100%",
                                fontFamily,
                              }}
                            >
                              <Chip
                                label={promoCode}
                                style={{
                                  marginRight: "1rem",
                                  borderRadius: "1em",
                                  fontSize: "1rem",
                                  padding: "0.5rem",
                                  border: "2px solid #008000",
                                  color: "#008000",
                                  fontFamily,
                                }}
                                variant="filled"
                                onDelete={async () => await handleRemovePromoCode()}
                              />
                            </Box>
                          </Grid>
                      }

                      {/* Apply button - 3 columns, right aligned */}

                    </Grid>

                    <div className="mt-2">
                      <p
                        style={{
                          fontSize: "11px",
                          fontWeight: "700",
                          color: "#4B5157",
                          margin: "0",
                          fontFamily
                        }}
                      >
                        Cancellation Policy
                      </p>
                      <p
                        style={{
                          fontSize: "10px",
                          fontWeight: "400",
                          color: "#4B5157",
                          fontFamily
                        }}
                      >
                        Refer to <a href="#" style={{ fontFamily }}>cancellation policy</a>  or For cancellation <Link to={`/events/${eventName}/contact`} style={{ fontFamily }}>contact us</Link>
                      </p>
                    </div>
                    <Grid container>
                      <Grid item xs={12}>
                        <CustomButton
                          text="Proceed"
                          size="lg"
                          className="mt-2 py-1 px-3"
                          block={true}
                          onClick={() => handleOrder(totalAmount)}
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <div
              style={{
                display: "flex",
                height: "50vh",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  height: "48vh",
                  width: isMob ? "80vw" : "30vw",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  backgroundColor: "white",
                  borderRadius: "10px",
                }}
              >
                <img
                  src={require("../Images/Group 1000002958.png")}
                  style={{
                    objectFit: "contain",
                    height: "25vh",
                    width: "25vh",
                  }}
                />
                <span
                  style={{
                    fontWeight: "700",
                    color: "black",
                    fontSize: "1.1em",
                  }}
                >
                  Your Cart is Empty
                </span>
                <span
                  style={{
                    fontWeight: "500",
                    color: "#555557",
                    fontSize: "0.8em",
                  }}
                >
                  Looks like you haven’t added anything to your cart yet
                </span>
                <div
                  style={{
                    height: "5vh",

                    backgroundColor: "#FE3B3E",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    borderRadius: "0.6em",
                    fontWeight: "bold",
                    cursor: "pointer",
                    margin: '10px'
                  }}
                  onClick={() => navigate(`/events/${eventName}`)}
                >
                  <span>Go Home</span>
                </div>
              </div>
            </div>
          )
          }
        </>
      )}
      {
        open ? (
          <PaymentForm
            open={open}
            onClose={onClose}
            handleCompleteOrder={handleCompleteOrder}
            eventId={eventId}
            userId={userId}
          />
        ) : (
          ""
        )
      }
      <Footer />
    </div >
  );
};

export default Cart;
const styles = {
  button: {
    backgroundColor: "#F6F2F2",
    border: "none",
    borderRadius: "20px",
    width: "30%",
    height: "100%",
    cursor: "pointer",
    fontSize: "18px",
  },
  input: {
    width: "40%",
    textAlign: "center",
    border: "none",
    outline: "none",
    fontSize: "16px",
  },
  quantityContainer: {
    width: isMobile() ? "25vw" : "40%",
    disply: "flex",
    border: "1px solid #D9D9D9",
    borderRadius: "1rem",
  },
  container: {
    display: "flex",
    alignItems: "center",
  },
};